// extracted by mini-css-extract-plugin
export var getNotified = "index-module--getNotified--c5458";
export var klaviyoForm = "index-module--klaviyoForm--ade19";
export var socials = "index-module--socials--2f23e";
export var wordBreak = "index-module--word-break--d7f79";
export var wrapper = "index-module--wrapper--fd36a";